import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const NAV = [
  { label: "Client Results", href: "/#results" },
  { label: "FAQ", href: "/#faq" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Contact", to: "/contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-all ${
        scrolled
          ? "bg-white/90 backdrop-blur-md shadow-sm"
          : "bg-white"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3 sm:px-8">
        <Link to="/" className="flex items-center">
          <img
            src="/logo/logo-lg.webp"
            alt="The 7 Figure Cleaner logo"
            className="h-[58px] w-auto object-contain sm:h-[68px]"
            width="800"
            height="288"
          />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) =>
            n.to ? (
              <Link
                key={n.label}
                to={n.to}
                className="text-[12px] font-semibold uppercase tracking-wider text-brand-black transition-colors hover:text-brand-blue"
              >
                {n.label}
              </Link>
            ) : (
              <a
                key={n.label}
                href={n.href}
                className="text-[12px] font-semibold uppercase tracking-wider text-brand-black transition-colors hover:text-brand-blue"
              >
                {n.label}
              </a>
            )
          )}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/offer"
            className="hidden items-center justify-center gap-2 rounded-2xl bg-brand-blue px-5 py-3 text-[12px] font-black uppercase tracking-wider text-white shadow-lg shadow-blue-200/60 ring-1 ring-blue-700/10 transition-all hover:bg-blue-600 active:scale-[0.98] sm:inline-flex"
          >
            Check My Territory
            <ArrowRight className="h-4 w-4" />
          </Link>
          <button
            aria-label="Open menu"
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg ring-1 ring-gray-200 lg:hidden"
            onClick={() => setOpen((s) => !s)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-gray-100 bg-white lg:hidden">
          <div className="mx-auto flex max-w-6xl flex-col gap-1 px-5 py-3 sm:px-8">
            {NAV.map((n) =>
              n.to ? (
                <Link
                  key={n.label}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-3 text-sm font-semibold uppercase tracking-wider text-brand-black hover:bg-gray-50"
                >
                  {n.label}
                </Link>
              ) : (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-3 text-sm font-semibold uppercase tracking-wider text-brand-black hover:bg-gray-50"
                >
                  {n.label}
                </a>
              )
            )}
            <Link
              to="/offer"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-2xl bg-brand-blue px-5 py-3 text-sm font-black uppercase tracking-wider text-white"
            >
              Check My Territory <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
